interface CustomTableRowProps extends React.PropsWithChildren {
  onClick?: React.MouseEventHandler<HTMLTableRowElement>
  className?: string
}

const CustomTableRow = ({ children, onClick, className = '' }: CustomTableRowProps) => {
  return <tr onClick={onClick} className={className}>{children}</tr>
}

export default CustomTableRow
